module.exports = __webpack_public_path__ + "img/active-3.91c284c7.svg";